// src/react/local-storage.ts
var getFromLocalStorage = key => {
  if (typeof window === "undefined") {
    return void 0;
  }
  return window.localStorage.getItem(key) || void 0;
};
var setInLocalStorage = (key, value) => {
  if (typeof window === "undefined") {
    return;
  }
  window.localStorage.setItem(key, value);
};
export { getFromLocalStorage, setInLocalStorage };